<template>
  <div class="modalBackdrop" @click.self="$emit('close')">
    <div class="modalCard">
      <h3 class="modalTitle">Move to qualified</h3>
      <p class="modalSubtitle">This will move {{ count === 1 ? 'the candidate' : `${count} candidates` }} back into the qualified stage.</p>
      <textarea
        v-model="reasoning"
        class="modalTextarea"
        rows="2"
        placeholder="Reason for requalifying (optional)"
      />
      <div class="modalActions">
        <button class="btn secondary" type="button" @click="$emit('close')">Cancel</button>
        <button class="btn primary" type="button" @click="$emit('confirm', reasoning.trim() || null)">Move to qualified</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineProps<{
  count: number
}>()

defineEmits<{
  close: []
  confirm: [reasoning: string | null]
}>()

const reasoning = ref('')
</script>

<style scoped>
.modalBackdrop {
  position: fixed; inset: 0; background: rgba(0,0,0,0.45);
  display: flex; align-items: center; justify-content: center; z-index: 100;
}
.modalCard {
  background: var(--color-surface, #fff);
  border-radius: var(--radius-lg);
  padding: var(--space-5);
  width: 480px; max-width: 90vw;
  display: flex; flex-direction: column; gap: var(--space-3);
}
.modalTitle { margin: 0; font-family: var(--font-display); font-size: var(--fs-lg); }
.modalSubtitle { margin: 0; color: var(--color-text-secondary); font-size: var(--fs-sm); }
.modalTextarea {
  width: 100%; resize: vertical; padding: var(--space-2);
  border: 1px solid var(--color-border); border-radius: var(--radius-sm);
  font-family: var(--font-sans); font-size: var(--fs-sm);
}
.modalActions { display: flex; gap: var(--space-2); justify-content: flex-end; }
</style>
